import reactGA from "react-ga";
import { buildKeycloakLogoutUrl } from "../config/authConfig";
import { broadcastLogout, stopRefreshSession } from "../services/keycloakTokenService";
import { store, persistor } from "../store";

export const LOGOUT_FLAG_KEY = "ops_logged_out";

/**
 * @param {object} options
 * @param {boolean} [options.remote=false] - true when another tab initiated logout.
 *   Remote tabs only clear local session (no Keycloak redirect storm).
 */
export async function performLogout({
  auth,
  reduxLogout,
  history,
  username,
  remote = false,
}) {
  // Capture before clearing local/OIDC state — required for Keycloak SSO logout.
  const idToken =
    auth?.user?.id_token || store.getState()?.keycloakIdToken || null;

  if (username && !remote) {
    reactGA.event({
      category: "Logged Out",
      action: `${username} logged out at ${new Date().toString()}`,
    });
  }

  try {
    sessionStorage.setItem(LOGOUT_FLAG_KEY, "1");
  } catch (error) {
    // ignore
  }

  if (remote) {
    stopRefreshSession();
  } else {
    broadcastLogout();
  }

  reduxLogout();

  try {
    await persistor.flush();
  } catch (error) {
    console.error("Failed to flush persisted logout state:", error);
  }

  try {
    await auth.removeUser();
  } catch (error) {
    console.error("Failed to clear local OIDC user:", error);
  }

  if (remote) {
    if (history) {
      history.push("/login");
    }
    return;
  }

  // Full browser navigation to Keycloak end-session so the SSO session ends
  // and the logout appears in the Keycloak admin events.
  window.location.assign(buildKeycloakLogoutUrl(idToken));
}
